import '@angular/compiler';
import { LayoutSajuComponent } from './layout.saju/layout.saju.component';
import { PageSajuComponent } from './page.saju/page.saju.component';

import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { URLPattern } from 'urlpattern-polyfill';
import { UploadSession } from "src/libs/portal/saju/uploads";

const appRoutes: Routes = [
    {
        component: LayoutSajuComponent,
        "children": [
            {
                "path": "*",
                component: PageSajuComponent,
                "app_id": "page.saju"
            }
        ]
    }
];
const routes: Routes = [];

export class RouteInfo {
    public path: string = '';
    public segment: Record<string, string> = {};
}

(window as any).WizRoute = new RouteInfo();

const matchRoute = (pattern: string, url: UrlSegment[]) => {
    const urlPath = url.map(segment => segment.path).join('/');
    const matcher = new URLPattern({ pathname: `/${pattern}` });
    const matched = matcher.exec(`http://localhost/${urlPath}`);

    if (!matched?.pathname) return null;

    const posParams: Record<string, UrlSegment> = {};
    const routeInfo = (window as any).WizRoute as RouteInfo;

    for (const key in matched.pathname.groups) {
        const value = matched.pathname.groups[key];
        if (value) posParams[key] = new UrlSegment(value, {});
    }

    routeInfo.path = urlPath;
    routeInfo.segment = Object.fromEntries(
        Object.entries(posParams).map(([key, value]) => [key, value.path])
    );

    return { consumed: url, posParams };
};

for (const layout of appRoutes) {
    routes.push({
        path: '',
        component: layout.component,
        canActivateChild: [(_route: any, state: any) => inject(UploadSession).beforeNavigate(state.url)],
        children: (layout.children || []).map(child => ({
            runGuardsAndResolvers: 'always',
            matcher: (url: UrlSegment[]) => matchRoute(child.path, url),
            component: child.component
        }))
    });
}

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
